import { useEffect, useRef } from 'react';

/**
 * Author Dan Abramov
 * @see {@link https://overreacted.io/making-setinterval-declarative-with-react-hooks/}
 * @param {function} callback - Execute callback
 * @param {number} delay - Milliseconds
 */
function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);

      return () => clearInterval(id);
    }
  }, [callback, delay]);
}

export default useInterval;
